// extracted by mini-css-extract-plugin
export var cardContainer = "_os-0";
export var cardHeader = "_os-2";
export var collapsedState = "_os-3";
export var dragHandle = "_os-5";
export var dragHandleIcon = "_os-6";
export var dragging = "_os-1";
export var titleArea = "_os-4";